(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["simple-slideshow"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Initialize slideshows after a small delay to ensure DOM is fully loaded
    requestAnimationFrame(function () {
      initializeSlideshows();
    });

    function initializeSlideshows() {
      const slideshows = document.querySelectorAll('.slideshow-section');

      slideshows.forEach(function (slideshow) {
        const slides = slideshow.querySelectorAll('.slideshow-slide');
        const dots = slideshow.querySelectorAll('.slideshow-dot');
        const prevBtn = slideshow.querySelector('.slideshow-prev');
        const nextBtn = slideshow.querySelector('.slideshow-next');
        const autoplay = slideshow.getAttribute('data-autoplay') === 'true';
        const transitionSpeed = parseInt(slideshow.getAttribute('data-transition-speed')) || 5000;
        const transitionType = slideshow.getAttribute('data-transition-type') || 'fade';
        let currentSlide = 0;
        let slideInterval = null;
        let isAnimating = false;

        // Apply the correct transition class to the slideshow
        const slideshowContainer = slideshow.querySelector('.slideshow-container');
        if (slideshowContainer) {
          slideshowContainer.classList.add('transition-' + transitionType);
        }

        // Remove initial class after a moment to enable transitions
        setTimeout(() => {
          slides.forEach((slide) => {
            slide.classList.remove('initial');
          });
        }, 50);

        // Function to show a specific slide
        function showSlide(index, direction = 'next') {
          if (isAnimating) return;
          isAnimating = true;

          // Calculate correct index if out of bounds
          if (index >= slides.length) {
            index = 0;
          } else if (index < 0) {
            index = slides.length - 1;
          }

          // Update all dots - important to do this outside any conditionals
          dots.forEach((dot, i) => {
            if (i === index) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });

          // Prepare the new slide
          const nextSlide = slides[index];
          const currentActiveSlide = slideshow.querySelector('.slideshow-slide.active');

          // If it's the same slide, don't animate
          if (currentActiveSlide === nextSlide) {
            isAnimating = false;
            return;
          }

          // Set up slide direction classes
          const transitionOutClass = direction === 'prev' ? 'transitioning-out-right' : 'transitioning-out-left';
          const transitionInClass = direction === 'prev' ? 'transitioning-in-left' : 'transitioning-in-right';

          // Add the transition classes
          if (currentActiveSlide) {
            currentActiveSlide.classList.add(transitionOutClass);
          }

          // Make the next slide visible before adding classes
          nextSlide.style.visibility = 'visible';
          nextSlide.style.opacity = '0';
          nextSlide.style.zIndex = '3';

          // Force browser reflow to ensure CSS transitions work correctly
          void nextSlide.offsetWidth;

          nextSlide.classList.add(transitionInClass);

          // Show the current slide after a small delay to ensure transitions work
          setTimeout(() => {
            nextSlide.classList.add('active');
            if (currentActiveSlide) {
              currentActiveSlide.classList.remove('active');
            }
          }, 20);

          // After transition completes, clean up
          setTimeout(() => {
            slides.forEach((slide) => {
              if (slide !== nextSlide) {
                slide.classList.remove(transitionOutClass);
                slide.classList.remove(transitionInClass);
                slide.classList.remove('transitioning-out-left');
                slide.classList.remove('transitioning-out-right');
                slide.classList.remove('transitioning-in-left');
                slide.classList.remove('transitioning-in-right');
                // Only hide slides that aren't active
                if (!slide.classList.contains('active')) {
                  slide.style.visibility = '';
                  slide.style.opacity = '';
                  slide.style.zIndex = '';
                }
              }
              nextSlide.classList.remove(transitionInClass);
              nextSlide.style.opacity = '';
            });
            isAnimating = false;
          }, 520); // Slightly longer than your CSS transition duration

          currentSlide = index;
        }

        // Function to go to the next slide
        function nextSlide() {
          showSlide(currentSlide + 1, 'next');
        }

        // Function to go to the previous slide
        function prevSlide() {
          showSlide(currentSlide - 1, 'prev');
        }

        // Start autoplay if enabled
        function startAutoplay() {
          if (autoplay && slides.length > 1) {
            // Clear any existing interval first
            if (slideInterval) {
              clearInterval(slideInterval);
            }
            slideInterval = setInterval(nextSlide, transitionSpeed);
          }
        }

        // Reset autoplay when interaction happens
        function resetAutoplay() {
          if (slideInterval) {
            clearInterval(slideInterval);
            if (autoplay) {
              startAutoplay();
            }
          }
        }

        // Add click event to prev button
        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            resetAutoplay();
            prevSlide();
          });
        }

        // Add click event to next button
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            resetAutoplay();
            nextSlide();
          });
        }

        // Add click events to dots
        dots.forEach(function (dot, index) {
          dot.addEventListener('click', function () {
            resetAutoplay();
            showSlide(index);
          });
        });

        // Handle touch events for mobile swiping
        let touchStartX = 0;
        let touchStartY = 0;
        let touchEndX = 0;
        let touchEndY = 0;
        let isSwiping = false;
        let isHorizontalSwipe = false;

        // Track both X and Y positions to determine swipe direction
        slideshow.addEventListener(
          'touchstart',
          function (e) {
            touchStartX = e.changedTouches[0].screenX;
            touchStartY = e.changedTouches[0].screenY;
            isSwiping = true;
            isHorizontalSwipe = false; // Reset this flag on each new touch
          },
          { passive: true }
        );

        slideshow.addEventListener(
          'touchmove',
          function (e) {
            if (!isSwiping) return;
            
            // Determine if this is a horizontal or vertical swipe
            const currentX = e.changedTouches[0].screenX;
            const currentY = e.changedTouches[0].screenY;
            const deltaX = Math.abs(currentX - touchStartX);
            const deltaY = Math.abs(currentY - touchStartY);
            
            // If we haven't determined swipe direction yet, do so now
            if (!isHorizontalSwipe && (deltaX > 10 || deltaY > 10)) {
              // If the horizontal movement is greater than vertical, it's a horizontal swipe
              isHorizontalSwipe = deltaX > deltaY;
            }
            
            // Only prevent default behavior for horizontal swipes
            // This allows vertical scrolling to work normally
            if (isHorizontalSwipe) {
              e.preventDefault();
            }
          },
          { passive: false } // Must be false to allow preventDefault
        );

        slideshow.addEventListener(
          'touchend',
          function (e) {
            if (!isSwiping) return;
            
            touchEndX = e.changedTouches[0].screenX;
            touchEndY = e.changedTouches[0].screenY;
            
            // Only handle swipe if it was determined to be horizontal
            if (isHorizontalSwipe) {
              handleSwipe();
            }
            
            isSwiping = false;
          },
          { passive: true }
        );

        function handleSwipe() {
          // Detect swipe direction
          const swipeDistance = Math.abs(touchEndX - touchStartX);
          if (swipeDistance < 50) return; // Ignore small movements

          resetAutoplay();

          if (touchEndX < touchStartX) {
            // Swipe left - go to next slide
            showSlide(currentSlide + 1, 'next');
          } else {
            // Swipe right - go to previous slide
            showSlide(currentSlide - 1, 'prev');
          }
        }

        // Initialize with the first slide (already done in HTML)
        // Start autoplay if enabled
        startAutoplay();

        // Preload next slide images for smoother transitions
        function preloadNextSlideImage() {
          if (slides.length <= 1) return;

          let nextIndex = currentSlide + 1;
          if (nextIndex >= slides.length) {
            nextIndex = 0;
          }

          const nextSlide = slides[nextIndex];
          const nextImages = nextSlide.querySelectorAll('img');

          if (nextImages.length) {
            nextImages.forEach((img) => {
              if (img.dataset.src) {
                const preloadImage = new Image();
                preloadImage.src = img.dataset.src;
              }
            });
          }
        }

        // Initial preload
        preloadNextSlideImage();

        // Preload next slide after each transition
        slideshow.addEventListener('transitionend', function (e) {
          if (e.target.classList.contains('slideshow-slide')) {
            preloadNextSlideImage();
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
